import { StorageHelper } from '@smg-real-estate/hg-search-libs';

import { BundlePeriod } from '@/types';

const INSERTION_FUNNEL_STORAGE_NAMESPACE = 'insertion-funnel';

export function setPricingCampaignId(insertionId: string, pricingCampaignId?: string) {
  if (pricingCampaignId) {
    const storage = new StorageHelper(INSERTION_FUNNEL_STORAGE_NAMESPACE);
    storage.setLocalStorageItem(createPricingCampaignKey(insertionId), pricingCampaignId);
  }
}

function createPricingCampaignKey(insertionId: string): string {
  return `insertions.${insertionId}.pricingCampaignId`;
}

export function isMultiWeeksInsertion(period: BundlePeriod | number | undefined | null): boolean {
  return [BundlePeriod.TWO_WEEKS, BundlePeriod.FOUR_WEEKS, BundlePeriod.EIGHT_WEEKS].includes(
    period as BundlePeriod,
  );
}

/**
 * Checks if the free week period has not yet ended for a given first published date.
 * This logic mirrors the backend implementation in NIF API:
 * src/core/services/ListingImportService.ts
 *
 * This is used to determine if a T2T listing is within the free week period (first week).
 *
 * @param firstPublishedDate - The ISO date string when the insertion was first published
 * @param now - Optional current date for testing (defaults to new Date())
 * @returns true if the free week period (first week for T2T) has not yet ended
 */
export function isWithinFreeWeekPeriod(
  firstPublishedDate: string | null | undefined,
  now: Date = new Date(),
): boolean {
  if (!firstPublishedDate) {
    return false;
  }

  const publishedDate = new Date(firstPublishedDate);

  const year = publishedDate.getUTCFullYear();
  const month = publishedDate.getUTCMonth();
  const day = publishedDate.getUTCDate();

  // Create a date for 7 days later at the start of the day
  const freeWeekEndDate = new Date(Date.UTC(year, month, day + 7, 0, 0, 0, 0));

  return freeWeekEndDate > now;
}
